import { css } from '@linaria/core';
import { Link } from '@tanstack/react-router';

import { ROUTE_PATHS } from '@modules/route-paths';

const styles = {
  navigation: css`
    display: flex;
    align-items: center;
    gap: var(--ant-margin-xs);
    white-space: nowrap;

    a {
      padding: var(--ant-padding-xs);
      border-radius: var(--ant-border-radius);
      color: var(--ant-color-text-secondary);
      font-size: var(--ant-font-size);
      line-height: 24px;

      transition: 300ms ease;
    }
    a:hover,
    a[aria-current='page'] {
      color: var(--ant-color-primary);
      background: var(--ant-color-primary-bg);
    }
    a[aria-current='page'] {
      font-weight: 600;
    }
    @media (min-width: 1600px) {
      gap: var(--ant-margin-md);
    }
    @media (max-width: 991px) {
      flex-direction: column;
      align-items: stretch;
    }
  `,
};

interface HeaderNavigationProps {
  onNavigate?: () => void;
}

const HeaderNavigation = ({ onNavigate }: HeaderNavigationProps) => (
  <nav className={styles.navigation} aria-label="Navegação principal">
    <Link to={ROUTE_PATHS.MARKETPLACE} onClick={onNavigate}>
      Marketplace
    </Link>
    <Link to={ROUTE_PATHS.DECK_MARKETPLACE} onClick={onNavigate}>
      Decks
    </Link>
    <Link to={ROUTE_PATHS.HOW_TO_SELL} onClick={onNavigate}>
      Como vender
    </Link>
    <Link to={ROUTE_PATHS.EVENTS} onClick={onNavigate}>
      Eventos
    </Link>
  </nav>
);

export default HeaderNavigation;
